<template>
  <div class="flex flex-col gap-2">
    <ColorTile :selected="isSelected(null)" :color="null">
      <div class="!w-full !h-full checkerboard" />
    </ColorTile>
    <ColorTile v-for="color in props.colors.slice(0, 2)" :onClick="select" :color="color" :selected="isSelected(color)">
      <div class="!w-full !h-full" :style="{ backgroundColor: color }" />
    </ColorTile>
  </div>
  <div class="flex flex-col gap-2">
    <ColorTile :selected="nativeColorPickerSelected" :onClick="select">
      <NativeColorPicker @color-picker-changed="select"></NativeColorPicker>
    </ColorTile>
    <ColorTile v-for="color in props.colors.slice(2, 4)" :onClick="select" :color="color" :selected="isSelected(color)">
      <div class="!w-full !h-full" :style="{ backgroundColor: color }" />
    </ColorTile>
  </div>
  <div class="flex flex-col gap-2">
    <ColorTile class="border-2" color="#ffffff" :onClick="select" :selected="isSelected('#ffffff')">
      <div class="!w-full !h-full bg-white" />
    </ColorTile>
    <ColorTile v-for="color in props.colors.slice(4, 6)" :onClick="select" :color="color" :selected="isSelected(color)">
      <div class="!w-full !h-full" :style="{ backgroundColor: color }" />
    </ColorTile>
  </div>
  <div class="flex flex-col gap-2" v-for="chunk in chunkedColors">
    <ColorTile v-for="color in chunk" :onClick="select" :color="color" :selected="color == props.selectedImageState?.selectedBackgroundColor">
      <div class="!w-full !h-full" :style="{ backgroundColor: color }" />
    </ColorTile>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ColorTile from "../prism/color_tile.vue";
import NativeColorPicker from "../prism/native_color_picker.vue";
import { useEditorStore } from "@/stores/editor_store";
import { rbgEditorApplyBackgroundColorV100 } from "kaleido-event-tracker";

export interface ColorTilesMobileProps {
  selectedImageState: any;
  colors: string[];
}
const props = defineProps<ColorTilesMobileProps>();

const store = useEditorStore();

// native color picker tile is only selected if there is a color set that is on in the colorList
const nativeColorPickerSelected = computed(() => {
  if (props.colors.includes(props.selectedImageState?.selectedBackgroundColor)) return false;
  if (props.selectedImageState?.selectedBackgroundColor == "#ffffff") return false;
  if (props.selectedImageState?.selectedBackgroundColor) return true;
});

const select = (color) => {
  props.selectedImageState.withSnapshot(() => {
    props.selectedImageState.setSelectedBackgroundPhotoUrl(undefined);
    props.selectedImageState.setSelectedBackgroundColor(color);
  });

  rbgEditorApplyBackgroundColorV100({ image_id: store.selectedImage.meta.id, color_value: color });
};

const isSelected = (color) => {
  return props.selectedImageState.selectedBackgroundColor === color;
};

const chunkedColors = computed(() => {
  const nonAddedColors = props.colors.slice(6);
  const chunkSize = 3;
  const chunks = [];
  for (let i = 0; i < nonAddedColors.length; i += chunkSize) {
    chunks.push(nonAddedColors.slice(i, i + chunkSize));
  }
  return chunks;
});
</script>
